export const getNextBatchOfCards = (flashcards, previousBatch = [], batchSize = 10) => {
  if (flashcards.length === 0) return [];

  // If all cards are reviewed, reset their reviewed status
  const allReviewed = flashcards.every(card => card.reviewed);
  if (allReviewed) {
    return [...flashcards]
      .sort(() => Math.random() - 0.5)
      .slice(0, batchSize);
  }

  // Get unreviewed cards first
  let availableCards = flashcards.filter(card => 
    !card.reviewed && !previousBatch.some(prevCard => prevCard.id === card.id)
  );

  // If no unreviewed cards excluding previous batch, include some reviewed cards
  if (availableCards.length === 0) {
    availableCards = flashcards.filter(card => 
      !previousBatch.some(prevCard => prevCard.id === card.id)
    );
  }

  // If still no cards, use all cards except the last from previous batch
  if (availableCards.length === 0 && previousBatch.length > 0) {
    availableCards = flashcards;
  }

  // Ensure we always have at least one card
  if (availableCards.length === 0) {
    availableCards = flashcards;
  }

  const shuffled = [...availableCards].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, batchSize);
};
